export enum CommonCustomizationType {
    /**
     * 照片定制
     */
    PICTURE_CUSTOMIZATION = "PICTURE_CUSTOMIZATION",
    /**
     * 照片打印
     */
    PICTURE_PRINTER = "PICTURE_PRINTER",
}

export enum CustomizationType {
    /**手机壳定制 */
    CELL_PHONE_CUSTOMIZATION = "CELL_PHONE_CUSTOMIZATION",

    /**通用定制 */
    COMMON_CUSTOMIZATION = "COMMON_CUSTOMIZATION",
}
